import { LayoutLoading } from 'components/LayoutLoading'

export const VendorLayout = (props: { children: any; loading?: boolean }) => {
  const { children, loading = false } = props

  return (
    <>
      <LayoutLoading show={loading} />
      <div className="max-w-screen-2xl m-auto relative py-6 px-2 bg-white">{children}</div>
    </>
  )
}
